export const SUBSCRIPTION_TYPE = {
  physical: 'FISICA',
  mix: 'MIXTA',
  digital: 'DIGITAL',
}
